export default __webpack_public_path__ + "static/blob10-343b4e7686f3515f862918a74b7dbfd0.svg";